


















































































































import Vue from "vue";

import NavigationButton from "@/components/NavigationButton.vue";
import ButtonCheckBox from "@/components/ButtonCheckBox.vue";
import CheckBox from "@/components/CheckBox.vue";
import DateTimeInput from "../../../../components/DateTimeInput.vue";
import DateInput from "../../../../components/DateInput.vue";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";


import eventBus from "@/services/eventBus";
import GlobalStore from "@/models/GlobalStore";
import IconButton from "@/components/IconButton.vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import store, { InterfaceStore } from "../../services/InterfaceStore";



//Place imports here

interface Data {
  store: InterfaceStore;
  showSendRequestConfirm: boolean;
}

interface Methods {
  sendRequest(): void;
}

interface Computed {
  asd1: number;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
    NavigationButton,
    // ButtonCheckBox,
    // CheckBox,
    // DateInput,
    // DateTimeInput,
    DateInput,
    // IconButton
  },

  data() {
    return {
      store,
      showSendRequestConfirm: false,
    };
  },

  computed: {
    asd1() {
      return 1;
    },
  },

  methods: {
    sendRequest() {
      console.warn("asdas");
      this.showSendRequestConfirm = !this.showSendRequestConfirm;
    },
  },
});
